export default __webpack_public_path__ + "static/media/downSelected.0a6bca1e.svg";